import { ReportSheetAssignComponent } from './report-sheet-assign/report-sheet-assign.component';
/**
 * Routing local pour l'edition des rapports.
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// from lingueo
import { AuthGuard } from '../../../../shared/src/lib/guard/auth.guard';
// from module
import { ReportsComponent } from './reports.component';
import { InfoComponent } from './report/info/info.component';
import { Step1Component } from './report/step1/step1.component';
import { Step2Component } from './report/step2/step2.component';
import { Step2firstComponent } from './report/step2first/step2first.component';
import { ListReportComponent } from './list/list.component';
import { MaintenanceGuard } from '../../../../shared/src/lib/guard/maintenance.guard';
import { AbsentComponent } from './report/absent/absent.component';
import { ReportExerciceOffsiteAssignComponent } from './report-offsite-assign/report-offsite-assign.component';
import { AssignExerciceComponent } from '../upcoming-classes/assign-exercice/assign-exercice.component';

export const routes: Routes = [
  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [MaintenanceGuard],
    children: [
      { path: '', component: ListReportComponent, canActivate: [AuthGuard] },
      { path: 'info/:id', component: InfoComponent, canActivate: [AuthGuard] },
      { path: 'absent/:id', component: AbsentComponent, canActivate: [AuthGuard] },
      { path: 'edit/:id', component: Step1Component, canActivate: [AuthGuard] },
      { path: 'edit/:id/step2', component: Step2Component, canActivate: [AuthGuard] },
      { path: 'edit/:id/step2first', component: Step2firstComponent, canActivate: [AuthGuard] },
      { path: 'edit/:id/assignsheet/:occurence_id', component: ReportSheetAssignComponent, canActivate: [AuthGuard] },
      { path: 'edit/:id/assignexercice/:occurence_id', component: ReportExerciceOffsiteAssignComponent, canActivate: [AuthGuard] },
      { path: 'edit/:occurence_id/assign-exercice/:type/category/:category/formation/:id', component: AssignExerciceComponent },
      { path: 'edit/:occurence_id/assign-exercice/:type/formation/:id', component: AssignExerciceComponent },
    ]
  }
]


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
